<template>
  <div class="flex justify-center h-full" ref="parentDom">
    <liste-activity :items="datas" />
    <m-p-legend ref="legend" @download="$emit('makereport')" />
    <div
      ref="diagram"
      :style="{
        height: height + (disableResponsive ? 50 : 0) + 'px',
        width: width + (disableResponsive ? 60 : 0) + 'px',
      }"
    >
      <div
        :style="{
          height: height + 'px',
          width: width + 'px',
        }"
        class="relative mx-auto border-b-2 border-l-2  text-base-content border-primary"
        :class="{ 'mt-4': disableResponsive }"
      >
        <div class="grid w-full h-full grid-cols-6 grid-rows-6">
          <!-- (1,y) -->
          <div
            class="grid grid-rows-6 row-span-6 mb-2 ml-2  bg-gradient-to-b from-rouge to-red-400"
          >
            <div
              v-for="item in [1, 2, 3, 4, 5, 6].reverse()"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[1 - 1][item - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[1 - 1][item - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[1 - 1][item - 1].length > 1,
                }"
              >
                {{
                  positioned[1 - 1][item - 1].length == 1
                    ? "R" + positioned[1 - 1][item - 1][0].$id
                    : "+" + positioned[1 - 1][item - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[1 - 1][item - 1]"
                :items="positioned[1 - 1][item - 1]"
              />
            </div>
          </div>
          <!-- (2, y) -->
          <div
            class="grid grid-rows-5 row-span-5 mb-2 ml-2  bg-gradient-to-b from-yellow-500 to-yellow-100"
          >
            <div
              v-for="item in [2, 3, 4, 5, 6].reverse()"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[2 - 1][item - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[2 - 1][item - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[2 - 1][item - 1].length > 1,
                }"
              >
                {{
                  positioned[2 - 1][item - 1].length == 1
                    ? "R" + positioned[2 - 1][item - 1][0].$id
                    : "+" + positioned[2 - 1][item - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[2 - 1][item - 1]"
                :items="positioned[2 - 1][item - 1]"
              />
            </div>
          </div>

          <!-- (2, y) -->
          <div
            class="grid grid-rows-4 row-span-4 mb-2 ml-2  bg-gradient-to-b from-blue-800 to-blue-400"
          >
            <div
              v-for="item in [3, 4, 5, 6].reverse()"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[3 - 1][item - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[3 - 1][item - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[3 - 1][item - 1].length > 1,
                }"
              >
                {{
                  positioned[3 - 1][item - 1].length == 1
                    ? "R" + positioned[3 - 1][item - 1][0].$id
                    : "+" + positioned[3 - 1][item - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[3 - 1][item - 1]"
                :items="positioned[3 - 1][item - 1]"
              />
            </div>
          </div>
          <div
            class="grid grid-cols-3 col-span-3 grid-rows-3 row-span-3 mb-2 ml-2  bg-gradient-to-tr from-green-400 to-green-800"
          >
            <div
              v-for="item in [4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][6 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][6 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][6 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][6 - 1].length == 1
                    ? "R" + positioned[item - 1][6 - 1][0].$id
                    : "+" + positioned[item - 1][6 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][6 - 1]"
                :items="positioned[item - 1][6 - 1]"
              />
            </div>

            <div
              v-for="item in [4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][5 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][5 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][5 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][5 - 1].length == 1
                    ? "R" + positioned[item - 1][5 - 1][0].$id
                    : "+" + positioned[item - 1][5 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][5 - 1]"
                :items="positioned[item - 1][5 - 1]"
              />
            </div>

            <div
              v-for="item in [4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][4 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][4 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][4 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][4 - 1].length == 1
                    ? "R" + positioned[item - 1][4 - 1][0].$id
                    : "+" + positioned[item - 1][4 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][4 - 1]"
                :items="positioned[item - 1][4 - 1]"
              />
            </div>
          </div>
          <div
            class="grid grid-cols-3 col-span-3 mb-2  bg-gradient-to-r from-blue-400 to-blue-800"
          >
            <div
              v-for="item in [4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][3 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][3 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][3 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][3 - 1].length == 1
                    ? "R" + positioned[item - 1][3 - 1][0].$id
                    : "+" + positioned[item - 1][3 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][3 - 1]"
                :items="positioned[item - 1][3 - 1]"
              />
            </div>
          </div>
          <div
            class="grid grid-cols-4 col-span-4 mb-2  bg-gradient-to-r from-yellow-100 to-yellow-500"
          >
            <div
              v-for="item in [3, 4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][2 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][2 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][2 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][2 - 1].length == 1
                    ? "R" + positioned[item - 1][2 - 1][0].$id
                    : "+" + positioned[item - 1][2 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][2 - 1]"
                :items="positioned[item - 1][2 - 1]"
              />
            </div>
          </div>
          <div
            class="grid grid-cols-5 col-span-5 mb-2  bg-gradient-to-r from-red-400 to-rouge"
          >
            <div
              v-for="item in [2, 3, 4, 5, 6]"
              :key="item"
              class="flex items-center justify-center"
            >
              <div
                v-if="disableResponsive && positioned[item - 1][1 - 1]"
                class="flex items-center justify-center rounded-full  w-14 h-14 bg-primary full"
                :class="{
                  'bg-primary text-primary-content':
                    positioned[item - 1][1 - 1].length == 1,
                  'bg-secondary text-secondary-content':
                    positioned[item - 1][1 - 1].length > 1,
                }"
              >
                {{
                  positioned[item - 1][1 - 1].length == 1
                    ? "R" + positioned[item - 1][1 - 1][0].$id
                    : "+" + positioned[item - 1][1 - 1].length
                }}
              </div>
              <MPBullet
                v-if="!disableResponsive && positioned[item - 1][1 - 1]"
                :items="positioned[item - 1][1 - 1]"
              />
            </div>
          </div>
        </div>

        <span
          class="
            absolute
            top-[-1px]
            left-[-1px]
            translate-x-[-50%] translate-y-[-50%]
          "
          :class="{ 'top-[-0.35rem] hidden': disableResponsive }"
        >
          <i class="fas fa-chevron-up"> </i>
        </span>

        <span
          class="
            absolute
            bottom-[-1px]
            right-[-1px]
            translate-x-[50%] translate-y-[50%]
          "
          :class="{ 'bottom-[0.35rem] hidden': disableResponsive }"
        >
          <i class="fas fa-chevron-right"> </i>
        </span>

        <span
          class="absolute text-4xl -rotate-90 -left-36 top-32 logo-font"
          :class="{
            '-left-20 !text-lg  font-bold whitespace-nowrap': disableResponsive,
          }"
          style="text-orientation: mixed"
          >Importance de l'activité</span
        >

        <span
          class="absolute text-4xl right-4 -bottom-8 logo-font"
          :class="{
            '-bottom-8 !right-20 !text-lg font-bold whitespace-nowrap':
              disableResponsive,
          }"
          >Facilité de mise en oeuvre</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import MPBullet from "./MPBullet.vue";
import MPLegend from "./MPLegend.vue";
import ListeActivity from "./ListeActivity.vue";
import * as htmlToImage from "html-to-image";
export default {
  components: { MPBullet, ListeActivity, MPLegend },
  name: "ActivityDiagram",
  props: {
    positioned: Array,
    datas: Array,
  },
  data() {
    return {
      width: 720,
      height: 720,
      disableResponsive: false,
      paperh: 297,
      paperw: 210,
    };
  },
  created() {
    // Setup a timer
    var timeout;
    var self = this;
    window.addEventListener(
      "resize",
      function () {
        console.log("no debounce");

        // If there's a timer, cancel it
        if (timeout) {
          this.clearTimeout(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = setTimeout(self.drawAll, 400);
      },
      false
    );
  },
  unmounted() {
    window.removeEventListener("resize", this.drawAll);
  },

  mounted() {
    this.drawAll();
  },

  methods: {
    drawAll() {
      var par = this.$refs.parentDom;
      if (this.disableResponsive) return;
      this.width = Math.min(par.clientHeight, par.clientWidth) - 40;
      this.height = Math.min(par.clientHeight, par.clientWidth) - 40;
      console.log(this.width);
    },

    async downloadImage() {
      this.disableResponsive = true;
      await new Promise((resolve) => setTimeout(resolve, 500));
      var dataUrl = await htmlToImage.toPng(this.$refs.diagram, {
        //canvasWidth: 1800,
        /*  width: 1200,
        //canvasWidth: 400,
        //canvasHeight: 1200,
        height: 900, */
        //style: { padding: "100px", width: "800px", height: "800px" },
      });
      this.disableResponsive = false;
      var dataUrl2 = await htmlToImage.toPng(
        this.$refs.legend.getLengendElement()
      );

      var el = this.$refs.legend.getLengendElement();
      var rect = el.getBoundingClientRect();
      var link = document.createElement("a");
      link.download = "relation-diagram.jpeg";
      link.href = dataUrl;

      return {
        data: dataUrl,
        legend: dataUrl2,
        width: (rect.width || el.offsetWidth) * 0.2645833333,
        height: (rect.height || el.offsetHeight) * 0.2645833333,
        title: "Analyse Relationnel des acteurs",
      };
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style>
</style>
